import * as yup from 'yup';
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import dayjs from 'dayjs';

const t = i18n.getFixedT(getLocale(), 'common');

const minDate = dayjs('2015-01-01');
const maxDate = dayjs('2099-12-31');

const dateValidation = (name: string) =>
  yup
    .date()
    .min(
      minDate.toDate(),
      t('validation.greaterThan', { field: minDate.format('DD-MM-YYYY') })
    )
    .max(
      maxDate.toDate(),
      t('validation.lessThan', { field: maxDate.format('DD-MM-YYYY') })
    )
    .notRequired()
    .typeError(t('validation.invalid', { name: t(name) }));
export const filterSchema = yup.object({
  startDate: dateValidation('startDate'),
  endDate: dateValidation('endDate')
});
